import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { MessageBusService } from 'src/app/core/services/message-bus.service';
import { RouteDialogService } from 'src/app/core/services/route-dialog.service';
import { LegalAgreementsRouteDialogModel } from 'src/app/shared/components/dialogs/route-dialog/route-dialog.component';
import { ComponentLookup } from 'src/app/shared/decorators/component-lookup.decorator';
import { IControlComponent } from 'src/app/shared/interfaces/control-component';
import { FormComponentData } from 'src/app/shared/models/people/form-control.model';
import { PublicProfile } from 'src/app/shared/models/people/public-profile.model';

@Component({
  selector: 'app-profile-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./../../styles/public-profile.css', './footer.component.css'],
  encapsulation: ViewEncapsulation.None
})
@ComponentLookup('ProfileFooterComponent')
export class FooterComponent implements OnInit, OnDestroy, IControlComponent  {
  
  data: FormComponentData;
  private ngUnsubscribe = new Subject();
  publicProfile: PublicProfile;  
  finishLoading: boolean = false;  
  currentYearStr: string;
  companyName: string;

  constructor(
    protected messageBusService: MessageBusService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    protected documentService: DocumentService,
    protected baseService: BaseService,
    private routeDialogService: RouteDialogService
  ) {}

  ngOnInit(): void {
    this.messageBusService.onSendPublicProfile()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.publicProfile = message.publicProfile;        
        this.currentYearStr = new Date().getFullYear().toString();
        this.companyName = this.baseService.getDirectoryTitle();

        this.finishLoading = true;
      });
      
    this.baseService.sendComponentFinishLoadingMessage(this.data);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openDialogLegalAgreements(): void {
    let routeDialogModel = new LegalAgreementsRouteDialogModel();
    routeDialogModel.route = 'disclaimer';
    this.routeDialogService.openDialog(routeDialogModel);
  }

}
